import merge from "lodash/merge";

interface IEllipsisOptions {
    char?: string;
    maxLength?: number;
}

const defaultOptions: IEllipsisOptions = {
    char: "…",
    maxLength: 30,
};

export const ellipsis = (text: string, options: IEllipsisOptions = defaultOptions): string => {
    const input = text?.trim();

    if (!input) {
        return "";
    }

    const opts = merge(defaultOptions, options);

    if (input.length <= opts.maxLength) {
        return input;
    }

    const candidate = input.substr(0, opts.maxLength).trim();

    return candidate + opts.char;
};
